<script>
    import { Card, CardBody, CardTitle, CardSubtitle, CardText } from 'sveltestrap'
    import Photo from './SubTaskPhotoButton.svelte'

    let diameter = 60
    let className = ''

    export { className as class }
    export let subtask
    export let taskId

</script>

<Card id={subtask.id} class={className}>
    <CardBody>
        <CardSubtitle class="font-weight-bold">{(subtask.title) ? subtask.title : ''}</CardSubtitle>
        <CardText>{(subtask.description) ? subtask.description : ''}</CardText>
        {#if subtask.photos}
        {#each subtask.photos as id}
        <Photo {diameter} {id} taskId={taskId} subtaskId={subtask.id}/>
        {/each}
        {:else}
        <p class="font-weight-bold">No photos available...</p>
        {/if}
    </CardBody>
</Card>
